"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePartnershipTexts = void 0;
const partnership_utils_1 = require("../utils/partnership.utils");
const usePartnershipTexts = ({ roleType, translate }) => {
    const baseKey = (0, partnership_utils_1.getBaseKey)(roleType);
    return (0, partnership_utils_1.getLiterals)(baseKey, translate);
};
exports.usePartnershipTexts = usePartnershipTexts;
exports.default = exports.usePartnershipTexts;
//# sourceMappingURL=usePartnershipTexts.hook.js.map